export const BULK_ENROLL = 'BULK_ENROLL';